/* eslint-disable @typescript-eslint/no-explicit-any */
export enum TrailerTypeSR {
    RegularTrailer = <any>'Prikolica',
    SemiTrailer = <any>'Polu prikolica',
}
